/* tslint:disable */
/* eslint-disable */
export enum LogLevel {
  None = 0,
  Logs = 1,
  Debug = 2
}
